export const businessInitialValues = {
    businesses: {
        loading: false,
        all: [],
        single: {},
        byToken: {},
        selected: {},
        selectedHeads: [],
        selectedHead: {},
        roles: [],
        defaultAgentWage: [],
        filtered: [],
        filteredSeo: [],
        isError: false,
    },
    branchNames: {
        loading: false,
        data: [],
    },
    currentBusiness: {
        loading: false,
        token: null,
        fundBalanceData: [],
        name: ""
    },
    companyNames: {
        loading: false,
        data: []
    },
    companyFeedback: {
        loading: false,
        data: [],
    },
    wages: {
        loading: false,
        single: null,
    },
    agentPaid: {},
    // Add other business-specific state properties
}

export const usersInitialValues = {
    loading: false,
    data: [],
    single: {},
    sales: [],
    boughts: [],
    userAgentWage: [],
    selectedItem: null,
    businesses: [],
    filtered: [],
    filteredItem: "",
    filterUsers: [],
    promoters: [],
    totalUsers: 1
}